export const formatPhoneNumber = (num) => {
    if (!num) return "-";
    const cleaned = num.replace(/\D/g, "");
    if (cleaned.startsWith("62") && cleaned.length > 10) {
        return `+${cleaned.slice(0, 4)} ${cleaned.slice(4, 8)}-${cleaned.slice(8)}`;
    }
    if (cleaned.startsWith("0") && cleaned.length > 9) {
        return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 8)}-${cleaned.slice(8)}`;
    }
    return num;
};